/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
export var NIVO_COLORS = [
    'var(--nx-swatch-teal-40)',
    'var(--nx-swatch-red-65)',
    'var(--nx-swatch-green-35)',
    'var(--nx-swatch-purple-60)',
    'var(--nx-swatch-orange-40)',
    'var(--nx-swatch-pink-60)',
    'var(--nx-swatch-turquoise-30)',
    'var(--nx-swatch-indigo-60)'
];
//# sourceMappingURL=nivo.js.map